import "./App.css";
import Rows from "./Row";
import requests from "./requests";
import Banner from "./Banner";
import Nav from "./Nav";

function App() {
  return (
    <div className="app">
      <Nav />
      <Banner />
      <Rows
        title="NETFLIX ORIGINALS"
        fetchUrl={requests.fetchNetflixOriginals}
        isLargeRow
      />
      <Rows title="Trending Now" fetchUrl={requests.fetchTrending} />
      <Rows title="Top Rated" fetchUrl={requests.fetchTopRated} />
      <Rows title="Action Movies" fetchUrl={requests.fetchActionMovie} />
      <Rows title="Comedy Movies" fetchUrl={requests.fetchComedyMovie} />
      <Rows title="Horror Movies" fetchUrl={requests.fetchHorrorMovie} />
      <Rows title="Romance Movies" fetchUrl={requests.fetchRomanceMovie} />
      <Rows title="Documentaries" fetchUrl={requests.fetchDocumentaries} />
    </div>
  );
}

export default App;
